import { useEffect, useState } from 'react';
import { formatNumber } from 'utils/utils';
import { Button } from '../Button';
import Loader from 'components/Loader';
import ProductQtyInput from 'components/ProductQtyInput';

export function BasketEditFabricItem(props) {
    const { item, updateFabricItem, close } = props;
    const [quantity, setQuantity] = useState(item.quantity);
    const basketItemTitle = () => item.fabricProductSupplier;
    const title = () => `Edit ${basketItemTitle()}`;
    const [loading, setloading] = useState(false);

    const handleQuantityChange = (value) => {
        if (value > 0 && value <= 300) {
            setQuantity(value)
        }
    }

    const handlerUpdate = async () => {
        setloading(true);
        await updateFabricItem({ ...item, quantity })
        setloading(false)
    }

    useEffect(() => {
        console.log(item)
    })

    return <Loader isLoading={loading}>
        <div className="row">
            <div className="col">
                <div className="subtitle1 mb-16 sm-text-24">{title()}</div>
            </div>
            <div className="col-auto">
                <span className="curtains-icon curtains-icon-close size-24 show-btn hide-btn" onClick={() => close()}></span>
            </div>
        </div>

        <div>
            <div>
                <span className="gray">Collection: </span>
                <a href={`/catalogue?Filter.CollectionId=${item.collectionId}`} className="underline">{item.collectionName}</a>
            </div>
            <div>
                <span className="gray">Colour:</span> {item.colour || 'None'}
            </div>
            <div>
                <span className="gray">Qty: {item.quantityUnitPrice}</span>
            </div>
        </div>

        <div className="body-text4 mt-24">£{formatNumber(item.price, 3)}</div>

        <div className="mb-16 mt-32" id="updateProductQuantity">
            <div className="dashed-line mb-24"></div>
            <div className="body-text3 gray mb-16">Quantity:</div>
            
            <ProductQtyInput initValue={quantity} onlyInt={false} digits={2} max={300} changeStep={0.1} label='m' onChange={handleQuantityChange} />
        </div>

        <div className="d-flex gap-16 mb-16 sm-column sm-gap-8 sm-mb-0">
            <div className="w-100 show-btn hide-btn">
                <Button name="UPDATE" onClick={async () => await handlerUpdate()} />
            </div>
        </div>
    </Loader>;
}
